import { Platform } from 'react-native';

import { Box, Header, Text } from '@fhs-legacy/universal-components';

/** Receipt rows use a parent `accessibilityLabel`; hide duplicate text from the subtree on assistive tech. */
const receiptInfoTextA11y = { importantForAccessibility: 'no-hide-descendants' as const };

export const ReceiptHeadInfoContainer = Box;

export const ReceiptInfoLabel = Text.withConfig({
  variant: 'copyTwo',
  marginRight: '$1',
  ...receiptInfoTextA11y,
});

export const ReceiptInfoDetail = Box.withConfig({
  flexShrink: 1,
});

export const ReceiptInfo = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  ...(Platform.OS === 'web' ? { tabIndex: 0 as const } : {}),
});

export const Title = Header.withConfig({
  variant: 'headerFour',
  margin: 0,
});

export const ReceiptDate = ReceiptInfoLabel;

export const ReceiptInfoDetailLabel = Text.withConfig({
  variant: 'copyTwo',
  ...receiptInfoTextA11y,
});
